import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { setBranchIsFiscal } from "./actions";
import {
  ButtonGroup,
  Button
} from 'react-bootstrap'

function IsFical(props) {
  function changeFiscalMode(e) {
    const { value } = e.target
    props.setBranchIsFiscal(value === "true")
  }
  return <React.Fragment>
    <h3>
      Deseja emitir notas fiscais <i className={`ml-2 fas fa-${props.isFiscal ? "check text-success" : "close text-danger"}`}></i> ?
  </h3>
    <ButtonGroup>
      <Button
        className={`${props.isFiscal ? "active" : ""}`}
        value="true" onClick={changeFiscalMode}>
        <span className="mr-3">
          Sim {
            props.isFiscal ? <i className="fas fa-check"></i> : null
          }
        </span>
      </Button>
      <Button
        className={`${!props.isFiscal ? "active" : ""}`}
        variant="danger" value="false" onClick={changeFiscalMode}>
        <span className="ml-3">
          Não {
            !props.isFiscal ? <i className="fas fa-close"></i> : null
          }
        </span>
      </Button>
    </ButtonGroup>

  </React.Fragment>
}

const mapStateToProps = state => ({
  isFiscal: state.isFiscal
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setBranchIsFiscal
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(IsFical);



// WEBPACK FOOTER //
// ./src/components/pages/branches/create/steps/is-fiscal.jsx